import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NewModalModule } from 'outshared-lib';
import { BonusMalusModalComponent } from './bonus-malus-modal.component';

@NgModule({
    imports: [
        CommonModule,
        NewModalModule,
    ],
    exports: [
        BonusMalusModalComponent,
    ],
    declarations: [
        BonusMalusModalComponent,
    ],
})
export class BonusMalusModalModule { }
